module.exports = __webpack_public_path__ + "static/media/Zerol0l.1fee5af3.png";